import { render, staticRenderFns } from "./BCXSuggestionBox.vue?vue&type=template&id=47ae74d6&scoped=true"
import script from "./BCXSuggestionBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXSuggestionBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXSuggestionBox.vue?vue&type=style&index=0&id=47ae74d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae74d6",
  null
  
)

export default component.exports